import { ChangeEvent, ChangeEventHandler, forwardRef, memo, useCallback } from "react";
import { default as MaskedInput, MaskedInputProps } from "react-text-mask";
import { InputContainer, InputContainerProps } from "../../index";

export type CardDateFieldProps = Omit<InputContainerProps<MaskedInputProps>, "inputComponent" | "onChange" | "value"> & {
  onChange?: (value: string | null, e?: ChangeEvent<HTMLInputElement> | null) => void,
  value?: string | null
}

export const CardDateField = memo(forwardRef<HTMLInputElement, CardDateFieldProps>((
  {
    onChange,
    value,
    ...props
  }, ref) => {
  const wrappedOnChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => onChange?.(e?.target?.value || null, e),
    [ onChange ]
  );

  return <InputContainer
    autoComplete="cc-exp"
    autoCorrect="off"
    spellCheck="false"
    inputMode="numeric"
    placeholder={"MM/YY"}
    {...props}
    inputComponent={MaskedInput}
    value={value || ""}
    ref={ref}
    type="text"
    mask={[ /[0-1]/, value?.startsWith("0") ? /[1-9]/ : /[0-2]/, '/', /[0-9]/, /[0-9]/ ]}
    onChange={wrappedOnChange}
  />;
}));

